import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { HdsCodeBlock } from '@hashicorp/design-system-components/components';
import { boxPadding } from 'core/modifiers';

export default class AzurePowershellCodeSnippet extends Component {
  get powershellSnippet() {
    return `powershellCodeSnippet`;
  }
  <template>
    {{t
      "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.terminal.message1"
      product="powershell"
      htmlSafe=true
    }}
    <div {{boxPadding "md 0 md 0"}}>
      {{t
        "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.terminal.message2"
      }}
    </div>
    <HdsCodeBlock
      @hasCopyButton={{true}}
      @value={{this.powershellSnippet}}
      @language="shell"
    />
    <div {{boxPadding "md 0 md 0"}}>
      {{t
        "components.page.hvn-peerings.detail.instructions.azure.pending-acceptance.terminal.message3"
      }}
    </div>
    <HdsCodeBlock
      @hasCopyButton={{true}}
      @value={{this.powershellSnippet}}
      @language="shell"
    />
  </template>
}
